import React, { Component } from 'react';
import { matchPath, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import translations from '../../translations/app-translations.json';

import Actions from '../actions';
import APP_DEFAULTS from '../constants/app-defaults';

import styles from './styles/pages/homepage.scss';
import APP_ROUTES from '../constants/app-routes';
import spreeStore from '../store';

class Layout extends Component {
    componentDidMount() {
        this.tick();
        this.interval = setInterval(this.tick, 1000);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.order !== this.props.order) {
            clearInterval(this.interval);
            this.interval = setInterval(this.tick, 1000);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    tick = () => {
        this.props.emptyCart(this.props.order, this.props.locale.currentLocale, this.props.cartState, this.props.location);
    }

    render() {
        return (
            <div style={{ display: 'flex', flexFlow: 'column', minHeight: '100vh' }}>
                <main className={`${styles.mainContainer} ${this.props.notShowMarginBottom ? '' : 'margin-bottom-50'}`}>
                    {this.props.children}
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    locale: state.locale,
    cartState: state.cartState,
});

const mapDispatchToProps = (dispatch) => ({
    emptyCart: (order, locale, cartState, location) => {
        let secondsToEmptyCart = cartState.cartRemoval;
        if (secondsToEmptyCart > 0 && cartState.hasExtraTimeCheckout) {
            secondsToEmptyCart += cartState.gracePeriod;
        }

        if (order.created_at && secondsToEmptyCart > 0) {
            const diffDate = (new Date()).getTime() - new Date(order.created_at).getTime();
            const rest = Math.round((secondsToEmptyCart - (diffDate / 1000)) / 60);
            const restOnSeconds = Math.round(secondsToEmptyCart - (diffDate / 1000));

            if (order.line_items && order.line_items.length > 0 && cartState.activeCart) {
                if ((cartState.timeMinutesLastAlert === 0 || restOnSeconds % 60 === 0 || rest > cartState.timeMinutesLastAlert)
                    && rest !== cartState.timeMinutesLastAlert && rest <= (secondsToEmptyCart / 60)) {
                    const index = APP_DEFAULTS.showCartExpiringMessageAt.indexOf(rest);
                    if (index > -1) {
                        const warningMessage = `${translations[locale]['cart-expiring-message-part1']}${rest}${translations[locale]['cart-expiring-message-part2']}`;
                        const lowestWarning = APP_DEFAULTS.showCartExpiringMessageAt.sort((a, b) => (a - b > 0 ? 1 : -1))[0];
                        if (lowestWarning === rest) {
                            toastr.error(warningMessage, '', {
                                timeOut: 60000,
                            });
                        } else {
                            toastr.warning(warningMessage, '', {
                                timeOut: 60000,
                            });
                        }
                    }
                    dispatch(Actions.setTimeMinutesLeft(rest));
                }
                dispatch(Actions.setTimeSecondsLeft(restOnSeconds));
            }

            if (order && order.id && diffDate / 1000 >= secondsToEmptyCart) {
                if (cartState.activeCart && !cartState.hasExtraTimeCheckout && matchPath(location.pathname, { exact: false, path: '/checkout' })) {
                    dispatch(Actions.setHasExtraTimeCheckout(true));
                } else if (!spreeStore.getState().order.isFinalStepHappening) {
                    spreeStore.dispatch(Actions.setIsFinalStepHappening(true));
                    dispatch(Actions.emptyCart(order, locale)).then((result) => {
                        if (result && result.ok) {
                            toastr.error(translations[locale]['cart-expiring-empty-cart']);
                            dispatch(push(APP_ROUTES.homePageRoute));
                        }
                    },
                    (error) => {
                        console.log(error);
                    }).finally(() => {
                        spreeStore.dispatch(Actions.setIsFinalStepHappening(false));
                    });
                }
            }
        }
    },
});

const LayoutWithRouter = withRouter(Layout);
export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithRouter);



/** WEBPACK FOOTER **
 ** ./src/components/layout.jsx
 **/